import { initSubRoutes } from '../../../../utils/router';

const RoutesSignalerArmeManquante = initSubRoutes({
    route: '/signaler-arme-manquante',
    subroutes: {},
    nom: 'Signaler une arme manquante',
});

export default RoutesSignalerArmeManquante;
